<template>
  <div>
    <ul class="lib__infobox-list">
      <InfoBox item level="primary">
        <template v-slot:icon>
          <img :src="require('@ores/css-library/assets/img/icons/electricity.svg')" alt="Electicity" />
        </template>
        <template>
          <h3 class="lib__text-uppercase">{{ $t('meter.smartMeter.installation') }}</h3>
        </template>
        <template v-slot:annexe>
          <h3>{{ $t('meter.price', [prime]) }}</h3>
          <p>{{ $t('meter.excludingVAT') }}</p>
        </template>
      </InfoBox>
      <template>
        <InfoBox item level="primary">
          <template>
            <h3 class="lib__text-uppercase">{{ $t('meter.smartMeter.oresIntervention') }}</h3>
            <div class='lib__text-gray-400 lib__text-small'>{{ $t('meter.smartMeter.boxInstallationDisclaimer') }}</div>
          </template>
          <template v-slot:annexe>
            <h3>- {{ $t('meter.price', [prime]) }}</h3>
            <p>{{ $t('meter.excludingVAT') }}</p>
          </template>
        </InfoBox>
        <InfoBox item level="primary">
          <template>
            <h3 class="lib__text-uppercase">{{ $t('meter.smartMeter.totalPrice') }}</h3>
          </template>
          <template v-slot:annexe>
            <h3>{{ $t('meter.price', [0]) }}</h3>
          </template>
        </InfoBox>
      </template>
    </ul>
    <Feedback icon level="alert">
      <p>{{ $t('meter.smartMeter.additionalPrice') }}</p>
    </Feedback>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'SmartMeterPriceCalculator'
})
export default class SmartMeterPriceCalculator extends Vue {
  @Prop({ type: Boolean, required: true }) public readonly isIndividual!: boolean

  public is25S60Opened: boolean = false
  public readonly prime: number = 243.22
}
</script>
